import { createFileRoute } from '@tanstack/react-router';
import { ProfilePage } from '@/page/ProfilePage';

export const Route = createFileRoute('/_app/u/$handle')({ component: ProfileRoute });

function ProfileRoute() {
  const { handle } = Route.useParams();
  return <ProfilePage handle={handle} />;
}
